import { useState } from 'react';

import { NonRequiredField, formatNonRequiredFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

export const useLogoImage = (nonRequiredFields?: NonRequiredField[] | null) => {
  const [logoImage, setLogoImage] = useState<File | undefined>();

  const transform = (values: GenericObject) => {
    formatNonRequiredFields(values, nonRequiredFields);
    values = { ...values, logo: logoImage };
    if (logoImage) {
      values.modify_image = true;
    } else {
      values.modify_image = null;
    }
    return values;
  };

  const handleChangeImageLogo = (logo: File | undefined) => {
    setLogoImage(logo);
  };

  return { logoImage, transform, handleChangeImageLogo };
};
